module.exports = __webpack_public_path__ + "static/img/sdgs_training_ph.9c47cd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sdgs_training_ph.png
// module id = ng2+
// module chunks = 0